import React from 'react'
import { ANALYTICS_CATEGORY_FLIGHTS } from '@/constants/analytics'
import analytics from '@/shared-utils/analytics'
import FlightsRecentSearchCardModule from './FlightRecentSearchModule'
import ViewAllActivityButton from './ViewAllAcitvityButton'
import { MostRecentFlightSearches } from '../types'
import StyledWrapper from '../TripActivity.styled'

function fireOnViewAllButtonClick() {
  analytics.fireEvent({
    category: ANALYTICS_CATEGORY_FLIGHTS,
    action: 'flights selection',
    label: 'view all recent activity'
  })
}

export default function Wrapper({
  mostRecentFlightSearchData
}: {
  mostRecentFlightSearchData: MostRecentFlightSearches
}) {
  return (
    <StyledWrapper borderRadius="2xl" bg="primary.light" mb="30px" as="section">
      <FlightsRecentSearchCardModule
        mostRecentFlightSearchData={mostRecentFlightSearchData}
      />
      <ViewAllActivityButton onClick={fireOnViewAllButtonClick} />
    </StyledWrapper>
  )
}
